<template>
  <div class="cities">
    <div class="text-2xl font-bold mb-6">Master Data City</div>
    <div class="border shadow-lg rounded-md bg-white">
      <div class="p-6 flex justify-between">
        <div class="flex items-center gap-4">
          <div class="w-60">
            <TextField type="text" v-model="searchTerm" :action="doSearch" placeholder="Masukan kata kunci" />
          </div>
          <div class="">
            <Button buttonText="Cari" @action="doSearch()" />
          </div>
        </div>
      </div>
      <TableComponent>
        <template v-slot:header>
          <td class="w-16 text-center">No.</td>
          <td class="w-96">Nama</td>
          <td class="w-96">Kode</td>
          <td>Kode Kota</td>
        </template>
        <template v-slot:body>
          <template v-if="filteredData && filteredData.length > 0">
            <tr v-for="(item, index) in filteredData" :key="item.code">
              <td class="w-16 text-center">{{ (currentPage - 1) * perPage + (index + 1) }}</td>
              <td class="w-96">{{ item.name }}</td>
              <td class="w-96">{{ item.code }}</td>
              <td>{{ item.city_code }}</td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td colspan="5" class="text-center">
                <div class="py-6">Tidak ada data yang tersedia.</div>
              </td>
            </tr>
          </template>
        </template>
      </TableComponent>
      <div class="px-6 text-sm text-neutral-500" v-if="filteredData && filteredData.length > 0">Menampilkan {{ start }} - {{ end }} dari {{ total }} data.</div>
      <div class="my-6 flex justify-center px-4" v-if="filteredData && filteredData.length > 0">
        <pagination :total-pages="totalPages" :total="total" :per-page="perPage" :current-page="currentPage" :has-more-pages="hasMorePages" @pagechanged="showMore"> </pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Table/Pagination')
  },
  data: () => ({
    searchTerm: '',
    page: 1,
    totalPages: 10,
    total: 100,
    perPage: 10,
    currentPage: 1,
    hasMorePages: true
  }),
  computed: {
    ...mapGetters('master', ['cities']),
    filteredData() {
      let temp = this.cities || []
      temp = temp.filter(item => {
        return item.code !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    }
  },
  methods: {
    ...mapActions('master', ['getCities']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getCityList(searchTerm = '') {
      this.showLoading()
      this.getCities({
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          search_keyword: searchTerm
        }
      })
        .then(res => {
          this.total = res.data.meta.total_item
          this.totalPages = res.data.meta.total_page
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    doSearch() {
      this.getCityList(this.searchTerm)
    },
    showMore(page) {
      this.$router.push({ path: '/master-data/city', query: { page: page } })
      this.page = page
      this.currentPage = page
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/master-data/city', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getCityList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getCityList()
      } else {
        this.$router.push({ path: '/master-data/city', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
